import { computed, ref } from "vue"
import { states } from '../main_store'
import { functions, httpsCallable } from '@/firebase/config'

const user = ref(computed(()=>{
    return states.value.user
}))

const confirmationResult = ref(computed(()=>{
    return states.value.confirmationResult
}))

const signup = ref(computed(()=>{
    return states.value.signup
}))

const is_reload = ref(computed(()=>{
    return states.value.is_reload
}))

const colorIcon = ref(computed(()=>{
    return states.value.colorIcon
}))

const matchedVols = ref(computed(()=>{
    return states.value.matchedVols
}))

const matchedReqs = ref(computed(()=>{
    return states.value.matchedReqs
}))

const getStringAfterDash = (inputString) => {
    if (inputString.includes('-')) {
        const parts = inputString.split('-');
        return parts[1];
    }
    return null;
}

const getStringBeforeDash = (inputString) => {
    if (inputString.includes('-')) {
        const parts = inputString.split('-');
        return parts[0];
    }
    return inputString;
}

function isValidIsraeliPhoneNumber(phoneNumber) {
    // Remove any non-numeric characters from the input
    const numericPhoneNumber = phoneNumber.replace(/\D/g, '');

    // Israeli mobile phone numbers should start with "05" followed by 7 digits
    const isIsraeliMobileNumber = /^05\d{8}$/.test(numericPhoneNumber);

    return isIsraeliMobileNumber;
}

function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

async function sendEmail(destinations, html, from, subject, attachments = null) {
    try {
        await httpsCallable(functions, 'send_email')({
            html,
            to: destinations,
            from,
            subject,
            attachments
        })
    } catch (err) {
        console.error('Error sending email:', err.message);
        throw new Error(err)
    }
}

export {
    user, confirmationResult, signup, is_reload, colorIcon, matchedReqs, matchedVols, getStringAfterDash, getStringBeforeDash, isValidIsraeliPhoneNumber, isValidEmail, sendEmail
}